import authService from 'ApiService/Auth/AuthService';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import { AuthContext } from 'contexts/AuthContext';
import Centered from 'layouts/auth/types/Centered';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import AddDetails from './AddDetails/index';

function OrgRegister() {
  const [schoolData, setSchoolData] = useState({
    name: '',
    password: '',
    confirmPassword: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    email: '',
    contactPhone: '',
    code: '',
    type: [],
    academicMonths: [
      { startMonth: 1, endMonth: 12, appliesTo: 'all', standards: [] },
    ],
  });
  const [verifyData, setVerifyData] = useState({ email: '', code: '' });
  const [loading, setLoading] = useState(false);
  const [isAccountVerified, setIsAccountVerified] = useState(false);
  const { state } = useContext(AuthContext);
  const router = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (['city', 'state', 'country'].includes(name)) {
      const filteredValue = value.replace(/[^A-Za-z ]/gi, '');
      const capitalizedValue =
        filteredValue.charAt(0).toUpperCase() + filteredValue.slice(1);
      setSchoolData({ ...schoolData, [name]: capitalizedValue });
    } else if (name === 'contactPhone' && value.length > 12) {
      return;
    } else if (name === 'postalCode' && value.length > 8) {
      return;
    } else {
      setSchoolData({ ...schoolData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    if (
      schoolData.name &&
      schoolData.password &&
      schoolData.confirmPassword &&
      schoolData.address &&
      schoolData.city &&
      schoolData.state &&
      schoolData.country &&
      schoolData.postalCode &&
      schoolData.contactPhone &&
      schoolData.type.length > 0
    ) {
      if (schoolData.password === schoolData.confirmPassword) {
        setLoading(true);
        try {
          const response = await authService.adminRegister(schoolData);
          if (response.data.success) {
            setSchoolData({
              name: '',
              code: '',
              password: '',
              confirmPassword: '',
              address: '',
              city: '',
              state: '',
              country: '',
              postalCode: '',
              email: '',
              contactPhone: '',
              type: [],
            });
            router('/auth/sign-in/org');
            toast.success(response.data.message);
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
          toast.error(error.response.data.message);
        }
      } else {
        toast.error('Password and Confirm Password not Matched.');
      }
    } else {
      toast.error('All fields are mandtory.');
    }
  };

  async function verifyCode(event) {
    event.preventDefault();
    if (!verifyData.email || !verifyData.code) {
      toast.error('All fields are mandatory');
    } else if (verifyData.code.length !== 6) {
      toast.error('A 6-digit code is required.');
    } else {
      try {
        const response = await authService.adminCheckDetails(verifyData);
        if (response.data.success) {
          setVerifyData({ email: '', code: '' });
          toast.success(response.data.message);
          setIsAccountVerified(true);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    }
  }

  function handleChangeForVerify(event) {
    setSchoolData({ ...schoolData, [event.target.name]: event.target.value });
    setVerifyData({ ...verifyData, [event.target.name]: event.target.value });
  }
  return (
    <>
      {isAccountVerified ? (
        <AddDetails
          loading={loading}
          setLoading={setLoading}
          schoolData={schoolData}
          setSchoolData={setSchoolData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      ) : (
        <Centered
          maincard={
            <Card extra=" max-w-[95%] md:max-w-[70%] h-max mt-32 md:mt-[40px] mx-2.5 md:mx-auto mb-auto pb-2.5 pt-8 md:pt-2.5 px-4 md:!p-[50px]">
              <h3 className="mt-1 text-4xl font-bold text-navy-700 dark:text-white">
                Register Organisation
              </h3>
              <p className="mb-4 ml-1 mt-[15px] text-[15px] text-gray-600">
                Enter your verification email and code to register!
              </p>
              <InputField
                maxLength={30}
                variant="auth"
                extra="mb-3"
                label="Email*"
                placeholder="eg. mail@example.com"
                id="email"
                name="email"
                type="text"
                onChange={handleChangeForVerify}
                value={verifyData.email}
                required
              />
              <InputField
                maxLength={6}
                variant="auth"
                extra="mb-5"
                label="Code*"
                placeholder="Code which you recevied on email."
                id="code"
                name="code"
                type="password"
                onChange={handleChangeForVerify}
                value={verifyData.code}
                required
              />
              <button
                onClick={verifyCode}
                className="w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                Register
              </button>
              <p className="mt-4 text-sm font-medium text-navy-700 dark:text-gray-500">
                Haven't received it?
                <span className="text-sm font-medium text-brand-500 dark:text-white">
                  {' '}
                  Contact us{' '}
                </span>
              </p>
            </Card>
          }
        />
      )}
    </>
  );
}

export default OrgRegister;
